<template>
  <div class="m-10" style="height:70%">
    <vue-scroll :ops="scrollBar">
      <div class="pr-10">
          <b-form-textarea
          v-model="newRemark"
      id="textarea"
      placeholder="Enter new Remark here..."
      rows="3"
      max-rows="6"
      v-if="saveVisible"
    ></b-form-textarea>
        <b-table
          :items="remarks"
          :fields="remarkFields"
          :per-page="pagination.pageLimit"
        >
          <template #head()="data">
              <b-row >
              <b-col cols="6" >
                  <span
              ><strong>Admin {{ data.label }}</strong></span>
              </b-col>
              <b-col cols="6" align="right">
                  <b-button pill variant="primary" size="sm" @click="addNewRemark" v-if="saveVisible">
                      Save
                  </b-button>
                  <b-button pill variant="primary" size="sm" @click="AddRemarkClick" 
                            v-b-tooltip.hover title="Add new remark" v-else>
                      <font-awesome-icon icon="plus" />
                  </b-button>
              </b-col>
              </b-row>
          </template>
          <template v-slot:cell(remarks)="data">
            <b-row>
              <b-col cols="6" class="pb-0">
                  <label class="user"
                  >{{ getLabel(data.item.remarks)}}</label
                >
                <label class="userId" v-if="data.item.remarks.user!==undefined?true:false"
                  >ID: {{ data.item.remarks.user!==undefined?data.item.remarks.user._id:"" }}</label
                >
              </b-col>
              <b-col cols="6" align="right">
                  <b-form-group
                      :label="data.item.remarks.createdTs"
                      class="m-0"
                      label-size="sm"
                    >
                  </b-form-group>
              </b-col>
              <b-col cols="12" class="m-0">
                  <h6>{{data.item.remarks.comments}}</h6>
                  
              </b-col>
            </b-row>
          </template>
        </b-table>
      </div>
    </vue-scroll>
    <b-row>
      <b-col cols="2" md="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-lg="5"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="pagination.pageLimit"
            id="perPageSelect"
            size="sm"
            :options="[10, 30, 50]"
            @input="pageLimitChange"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="7" md="6">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.total"
          :per-page="pagination.pageLimit"
          @change="changePage"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import moment from "moment";

export default {
  name: "driverRemarks",
  components: {
    
  },
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  watch: {},
  props: {
    driverId: String
  },
  data() {
    return {
      remarks: [],
      saveVisible:false,
      newRemark:"",
      remarkFields: [
        {
          key: "remarks"
        }
      ],
      pagination: {
        page: 1,
        pageLimit: 10
      }
    };
  },
  async created() {
    this.getRemarks();
  },
  methods: {
    changePage(pageNumber) {
      this.pagination.page = pageNumber;
      this.getRemarks();
    },
    pageLimitChange(val) {
      this.changePage(1);
    },
    AddRemarkClick(){
        this.saveVisible=true;
    },
    async addNewRemark(){
      if(this.newRemark!="")
      {
        let remark={
            driver:this.driverId,
            comments:this.newRemark
        };
        await shebahApi.api.drivers.addRemark(remark);
        this.getRemarks();
      }
      this.saveVisible=false;
    },
    async getRemarks() {
      let remarks = await shebahApi.api.drivers.remarks(
        this.driverId,
        this.pagination.page,
        this.pagination.pageLimit
      );
      this.remarks = this.remarkFactory(remarks.data);
      this.pagination = {
        pageCount: remarks.pageCount,
        total: remarks.total,
        page: remarks.page,
        pageLimit: remarks.pageLimit
      };
    },
    remarkFactory(remarks) {
      let newRemarks = [];
      for (let remark of remarks) {
          remark.createdTs=moment(remark.createdTs).format("DD-MM-YYYY HH:mm:ss");
        newRemarks.push({
          remarks: remark
        });
      }
      return newRemarks;
    },
    getLabel(remark){
      let label="";
      if(typeof remark.user!=='undefined'){
        label=remark.user.firstName+" "+remark.user.lastName;
      }
      else{
        label=remark.addedBy;
      }
      return label;
    }
  }
};
</script>
<style lang="scss">
.remarkLabel{
  text-transform: capitalize;
}
.userId
{ color:gray;
  text-decoration:none;
  font-size:11px;
}
.user
{ color:gray;
  font-size:13px;
  font-weight: bold;
  padding: 0%;
  margin-bottom: 0;
}
</style>>